<template>
  <div class="container_box" id="video_box">
    <div class="van_swipe">
      <!--vant van-swipe 滑动组件 -->
      <van-swipe
        :show-indicators="false"
        @change="onChange"
        vertical
        :loop="false"
      >
        <!-- :initial-swipe="current" -->
        <van-swipe-item
          v-for="(item, index) in videoList"
          :key="index"
          class="product_swiper"
        >
          <div class="video_container">
            <!--video属性
                    webkit-playsinline ios 小窗播放，使视频不脱离文本流，安卓则无效
                    微信内置x5内核，
                    x5-video-player-type="h5-page" 启用H5播放器,是wechat安卓版特性，添加此属性，微信浏览器会自动将视频置为全屏
                    x5-video-player-fullscreen="true" 全屏设置，设置为 true 是防止横屏
                    x5-video-orientation 控制横竖屏 landscape 横屏，portrain竖屏； 默认portrain
                    poster：封面
                    src：播放地址
            -->
            <video
              class="video_box"
              loop
              webkit-playsinline="true"
              x5-video-player-type="h5-page"
              x5-video-player-fullscreen="true"
              playsinline
              preload="auto"
              :poster="item.video_cover"
              :src="item.video_link"
              :playOrPause="playOrPause"
              @click="pauseVideo"
              @ended="onPlayerEnded($event)"
            ></video>
            <!-- 封面 -->
            <img
              v-show="isVideoShow"
              class="play"
              @click="playvideo"
              :src="item.cover"
            />
            <!-- 播放暂停按钮 -->
            <img
              v-show="iconPlayShow"
              class="icon_play"
              @click="playvideo"
              src="http://npjy.oss-cn-beijing.aliyuncs.com/images/file-1575340653940esdHR.png"
            />
          </div>
          <!-- 右侧头像、点赞、评论、分享功能 -->
          <div class="tools_right">
            <div class="tools_r_li">
              <img :src="userinfo.avatar" class="tag_image" />
              <i
                class="iconfont icon-jiahao tag_add"
                @click="checkSubscribe(userinfo.uid)"
              ></i>
            </div>
            <div
              class="tools_r_li"
              @click="
                isUserCollectVideo(item.isUserCollectVideo, index, item.id)
              "
            >
              <img
                v-if="item.isUserCollectVideo == 'N'"
                src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_vsc1.png"
                style="display: block;width: .5rem;"
              />
              <div class="tools_r_num" v-if="item.isUserCollectVideo == 'N'">
                收藏
              </div>
              <img
                v-if="item.isUserCollectVideo == 'Y'"
                src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_vsc2.png"
                style="display: block;width: .5rem;"
              />
              <div class="tools_r_num" v-if="item.isUserCollectVideo == 'Y'">
                已收藏
              </div>
            </div>
            <div class="tools_r_li" @click="showShareDialog(item)">
              <img
                src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_vshare.png"
                style="display: block;width: .5rem;"
              />
              <div class="tools_r_num">分享</div>
            </div>
            <!--  <div class="tools_r_li" @click="changeShare">
              <img
                src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_vxz.png"
                style="display: block;width: .5rem;"
              />
              <div class="tools_r_num">下载</div>
            </div> -->
          </div>
          <!-- 底部作品描述 -->
          <div class="production_box">
            <div class="production_name">{{ item.video_name }}</div>
          </div>
          <!--底部操作栏-->
          <div class="footer_gg">
            <!-- //存在广告 -->
            <div class="addimg" v-if="JSON.stringify(item.ad_info).length > 5">
              <div class="addimgs">
                <img :src="item.ad_info.ad_image" />
              </div>
              <div class="gg_text">
                <div class="gg_textTitle">{{ item.ad_info.ad_name }}</div>
                <div class="gg_textDec">
                  {{ item.ad_info.ad_describe }}
                </div>
              </div>
              <span
                class="editGg"
                @click="
                  goPageGG(
                    item.secret_key,
                    item.id,
                    JSON.stringify(item.ad_info)
                  )
                "
                >修改</span
              >
            </div>
            <!-- 不存在广告 -->
            <div class="addimg" v-if="JSON.stringify(item.ad_info).length < 5">
              <div class="addimgs">
                <img :src="userinfo.avatar" />
              </div>
              <div class="gg_text">
                <div class="gg_textTitle">{{ userinfo.nickname }}</div>
                <div class="gg_textDec" @click="addQianming">
                  {{
                    userinfo.personality
                      ? userinfo.personality
                      : "请添加您的个性签名"
                  }}
                </div>
              </div>
              <span
                class="editGg"
                @click="
                  goPageGG(
                    item.secret_key,
                    item.id,
                    JSON.stringify(item.ad_info)
                  )
                "
                >修改</span
              >
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>

      <!--分享弹框-->
      <div class="share_box dialog" v-if="shareTishi" @click="hideShareDialog">
        <img
          src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/fenxiang.png"
        />
      </div>
      <!-- 设置签名 -->
      <div class="setQianDialog dialog_MC" v-if="showQianDialog">
        <div class="setContent">
          <div class="setTitle">设置签名</div>
          <div class="setText">
            <textarea
              placeholder="设置签名,让别人了解你......"
              v-model="qianmingSign"
            ></textarea>
          </div>
          <div class="setbtns">
            <div class="setQuxiao" @click="setQianhide">取消</div>
            <div class="setYes" @click="saveQianSign">确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Swipe, SwipeItem, Toast } from "vant";
import {
  getShare,
  getVideoListNew,
  getVideoDetailsNew,
  getVideoCollectAddNew,
  getVideoCollectDelNew,
  getPersonalitySigNew
} from "@api/public";
import { getUser } from "@api/user";
import { cookie } from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
// 引入微信分享
import wx from "weixin-js-sdk";
Vue.use(Swipe, Toast).use(SwipeItem);
let sourceData = [];
let videoProcessInterval;
export default {
  name: "videindex",
  data() {
    let u = navigator.userAgent;
    return {
      showQianDialog: false,
      video_id: "",
      userAvatar:
        "https://1dogames.oss-cn-shenzhen.aliyuncs.com/01e97202202091149349670.jpg", //用户的头像
      current: 0,
      shareTishi: false,
      videoList: [],
      isVideoShow: true,
      playOrPause: true,
      video: null,
      iconPlayShow: true,
      isAndroid: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, // android终端
      isiOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      tabIndex: 0,
      showShareBox: false, //展示分享框
      commentPop: false, //是否展示评论弹框
      // 评论相关
      comment_text: "", //评论输入内容
      canSend: false, //是否可以发送
      videoComment: [],
      commentPlaceholder: "留下你精彩的评论吧", //评论Placeholder
      replayUserData: "",
      to_comment_id: "",
      videoProcess: 0, //视频播放进度
      page: 1,
      videolistOld: []
    };
  },
  watch: {
    //监听输入变化
    comment_text(newV, oldV) {
      newV == "" ? (this.canSend = false) : (this.canSend = true);
    }
  },
  mounted() {
    this.getUser();
    this.video_id = this.$route.query.id;
    this.getVideoDetailsNew();
    try {
      wx.config({
        debug: false,
        appId: "111",
        timestamp: "111",
        nonceStr: "111",
        signature: "111",
        jsApiList: [],
        userinfo: {}
      });
    } catch (e) {
      console.log(e);
    }

    //获取到视频资源后默认自动播放
    setTimeout(() => {
      this.playvideo();
    }, 500);
  },
  methods: {
    // 获取用户信息
    getUser() {
      getUser().then(res => {
        this.userinfo = res.data;
      });
    },
    // 初始获取相应的视频详情
    getVideoDetailsNew() {
      var data = "?video_id=" + this.video_id + "&key=";
      getVideoDetailsNew(data).then(res => {
        var cont = {
          video_name: res.data.video_name,
          id: res.data.id,
          secret_key: res.data.secret_key,
          video_cover: res.data.video_cover
        };
        this.setOpenShare(cont);
        this.videoList.push(res.data);
        console.log("videoList:", this.videoList);
        this.getVideolist();
      });
    },
    // 初始渲染视频列表
    getVideolist() {
      console.log("第" + this.page + "页");
      var data1 = "?page=" + this.page + "&limit=5";
      getVideoListNew(data1).then(res1 => {
        if (res1.data.length > 0) {
          for (var i = 0; i < res1.data.length > 0; i++) {
            var data2 = "?video_id=" + res1.data[i].id + "&key=";
            getVideoDetailsNew(data2).then(res2 => {
              this.videoList.push(res2.data);
            });
          }
        }
      });
    },
    //关注该作者
    checkSubscribe(id) {
      window.location.href = "/jiaodian/userWeizhan?uid=" + id;
    },
    //改变菜单
    changeTab(index) {
      this.tabIndex = index;
    },
    //改变收藏状态
    isUserCollectVideo(item, index, id) {
      if (this.videoList[index].isUserCollectVideo == "N") {
        console.log("  // 收藏");
        getVideoCollectAddNew({ id: id, type: "collect" })
          .then(res => {
            Toast(res.msg);
            this.videoList[index].isUserCollectVideo = "Y";
          })
          .catch(err => {
            Toast("收藏失败");
          });
      } else {
        console.log("  // 取消收藏");
        getVideoCollectDelNew({ id: id, type: "collect" })
          .then(res => {
            Toast(res.msg);
            this.videoList[index].isUserCollectVideo = "N";
          })
          .catch(err => {
            Toast("收藏失败");
          });
      }
    },
    //展示分享弹窗
    changeShare() {
      this.showShareBox = true;
    },
    //取消分享
    cancelShare() {
      this.showShareBox = false;
    },
    //滑动改变播放的视频
    onChange(index) {
      //改变的时候 暂停当前播放的视频
      clearInterval(videoProcessInterval);
      this.videoProcess = 0;
      let video = document.querySelectorAll("video")[this.current];
      video.pause();
      this.playOrPause = false;
      this.showShareBox = false;
      this.current = index; //当前播放第几个
      //非ios切换直接自动播放下一个
      this.pauseVideo();
      console.log(index);
      var cont = {
        video_name: this.videoList[index].video_name,
        id: this.videoList[index].id,
        secret_key: this.videoList[index].secret_key,
        video_cover: this.videoList[index].video_cover
      };
      this.setOpenShare(cont);
      //如果播放到倒数第二个，请求下一页数据
      if (this.current == this.videoList.length - 4) {
        console.log("如果播放到倒数第二个，请求下一页数据");
        this.loadNewData();
      }
    },
    //切换下一页
    loadNewData() {
      console.log("切换下一条视频");
      setTimeout(() => {
        this.page = this.page + 1;
        this.getVideolist();
        // this.videoList.push(...sourceData);
        // this.videoList.push(...sourceData);
      }, 500);
    },
    // 开始播放
    playvideo(event) {
      let video = document.querySelectorAll("video")[this.current];
      console.log("playvideo：" + this.current);
      this.isVideoShow = false;
      this.iconPlayShow = false;
      this.showShareBox = false;
      video.play();
      if (this.isiOS) {
        setTimeout(() => {
          //处理ios宽视频
          let documentW =
            document.documentElement.clientWidth || document.body.clientWidth;
          let docB = parseFloat(video.videoWidth / documentW);
          console.log("获取视频宽和屏幕比：" + docB);
          // 计算视频最适高度
          let realH = parseInt(video.videoHeight / docB);
          this.realH = realH + "px";
          console.log("视频最适高度：" + this.realH);
          this.$forceUpdate();
        }, 200);
      }

      videoProcessInterval = setInterval(() => {
        // this.changeProcess(video);
      }, 100);
    },
    pauseVideo() {
      //暂停\播放
      try {
        let video = document.querySelectorAll("video")[this.current];
        console.log("pauseVideo" + this.current);
        if (this.playOrPause) {
          video.pause();
          this.iconPlayShow = true;
          clearInterval(videoProcessInterval);
        } else {
          // wx.ready(() => {
          //     // 在微信的ready中进行播放 不管成功配置与否 都会执行ready
          //     video.play();
          // })
          video.play();
          video.pause();
          setTimeout(() => {
            video.play();
            this.iconPlayShow = false;
            videoProcessInterval = setInterval(() => {
              // this.changeProcess(video);
            }, 100);
          }, 100);
        }
        this.playOrPause = !this.playOrPause;
        this.showShareBox = false;
      } catch (e) {
        alert(e);
      }
    },
    //记录播放进度
    changeProcess() {
      let video = document.querySelectorAll("video")[this.current];
      let currentTime = video.currentTime.toFixed(1);
      let duration = video.duration.toFixed(1);
      this.videoProcess = parseInt((currentTime / duration).toFixed(2) * 100);
    },
    onPlayerEnded(player) {
      //视频结束
      this.isVideoShow = true;
      this.current += this.current;
    },
    goPageGG(key, id, item) {
      window.location.href = "/guanggao/index?secret_key=" + key + "&id=" + id;
    },
    //添加个性签名
    addQianming() {
      this.showQianDialog = true;
    },
    setQianhide() {
      this.showQianDialog = false;
    },
    saveQianSign() {
      var data = {
        personality: this.qianmingSign
      };
      getPersonalitySigNew(data)
        .then(res => {
          this.showQianDialog = false;
          this.userinfo.personality = this.qianmingSign;
          return this.$dialog.success(res.msg);
        })
        .catch(err => {
          return this.$dialog.error(err.msg);
        });
    },
    // 分享提示
    showShareDialog(cont) {
      this.shareTishi = true;
      this.setOpenShare(cont);
    },
    hideShareDialog() {
      this.shareTishi = false;
    },
    // 分享
    setOpenShare(cont) {
      var that = this;
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: "视频集，快乐的源泉",
            title: cont.video_name,
            link:
              "https://" +
              window.location.host +
              "/video/shareindex?id=" +
              cont.id +
              "&secret_key=" +
              cont.secret_key,
            imgUrl: cont.video_cover
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style scoped>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
}
.dialog img {
  display: block;
  width: 70%;
  margin-left: 26%;
}
.addimg {
  width: 100%;
  padding: 0.2rem 0.3rem;
  display: flex;
  position: relative;
  align-items: center;
}
.addimgs {
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.12rem;
  overflow: hidden;
  margin-right: 0.2rem;
}
.addimgs img {
  display: block;
  width: 100%;
  height: 100%;
}
.addimgs input {
  display: block;
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  left: 0;
  right: 0;
}
.addimg .gg_text {
  /* font-size: 0.26rem; */
  width: calc(100% - 2.5rem);
  position: relative;
}
.footer_gg {
  /*  position: absolute;
  bottom: 0;
  left: 0; */
  background: #fff;
}
.gg_textTitle {
  font-size: 0.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gg_textDec {
  font-size: 0.26rem;
  margin-top: 0.2rem;
  overflow: hidden;

  display: -webkit-box;

  -webkit-box-orient: vertical;

  -webkit-line-clamp: 2;
}
.clear {
  clear: both;
}

.back_i {
  position: fixed;
  top: 20px;
  left: 10px;
  width: 28px;
  z-index: 10;
}

.video-player {
  height: 100vh;
  width: 100vw;
}

.product_swiper {
  width: 100vw;
  height: 100vh;
}
span.editGg {
  background-image: linear-gradient(#fe8441, #ff4d19);
  color: #fff;
  font-size: 0.24rem;
  display: block;
  width: 0.8rem;
  text-align: center;
  line-height: 0.6rem;
  border-radius: 0.12rem;
}
.van_swipe {
  width: 100vw;
  height: 100vh;
  max-width: 550px;
  margin: 0 auto;
  position: relative;
}

.van-swipe {
  width: 100%;
  height: 100%;
}

.container_box {
  width: 100vw;
  height: 100vh;
  background: #000;
}

.video_box {
  /* max-height: 100%; */
  width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translate(-50%, -50%);
}

video {
  object-position: 0 0;
}

.icon_play {
  position: absolute;
  top: 44%;
  right: 0;
  left: 0;
  bottom: auto;
  margin: auto;
  z-index: 999;
  height: 60px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

.play,
.platStart {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
}

/*头像， 点赞，转发 */
.tag_image {
  width: 0.8rem !important;
  height: 0.8rem;
  border: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 50%;
  margin-bottom: 20px;
  position: relative;
  box-shadow: 0px 0px 10px #9d9d9d;
}

.tag_add {
  z-index: 1;
  position: absolute;
  left: 0;
  right: 0;
  display: inline-block;
  margin: 0 auto;
  width: 0.3rem;
  height: 0.3rem;
  bottom: -0.06rem;
  border-radius: 100%;
  background-image: url(https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_jia.png);
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.tag_dui {
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
  border-radius: 67px;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  margin: 0 auto;
  z-index: 1;
  font-size: 11px;
  color: #f44;
  background: #fff;
}

.tag_dui_active {
  opacity: 0;
  animation: showFollow 1.4s ease-in-out 0s;
}

.tag_add_num {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
}

@keyframes showFollow {
  0% {
    opacity: 1;
    color: #fff;
    background: #f44;
    transform: rotate(-180deg) scale(1);
  }
  35% {
    opacity: 1;
    color: #f44;
    background: #fff;
    transform: rotate(0deg) scale(1.2);
  }
  80% {
    opacity: 1;
    color: #f44;
    transform: scale(1.2);
  }
  100% {
    opacity: 0;
    display: none;
    color: #f44;
    transform: scale(0);
  }
}

.tools_right {
  z-index: 1001;
  position: absolute;
  right: 16px;
  bottom: 180px;
}

.tools_r_li {
  margin-bottom: 20px;
  color: #fff;
  font-size: 0.22rem;
  position: relative;
  text-align: center;
}
.tools_r_li > img {
  width: 0.5rem;
  margin: 0 auto;
}
.tools_r_li:last-child {
  margin-bottom: 0px;
}

.icon_right {
  margin-bottom: 5px;
  font-size: 42px;
  display: block;
  text-shadow: 0px 0px 10px #9d9d9d;
  /*transition: .5s;*/
}

.production_box {
  z-index: 1001;
  position: absolute;
  bottom: 2rem;
  text-align: left;
  padding: 0 15px 0 15px;
  color: #fff;
  width: 100%;
  left: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(rgba(0, 0, 0, 0.4)),
    to(transparent)
  );
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), transparent);
}

.production_name {
  font-weight: 700;
  font-size: 0.3rem;
  margin-bottom: 0.15rem;
}

.production_des {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  min-height: 0.6rem;
  font-size: 0.22rem;
}

.container_bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.85);
  height: 48px;
  /*border-top: 1px solid rgba(255, 255, 255, 0.7);*/
  max-width: 550px;
}

.production_top {
  display: inline-block;
  padding: 6px;
  margin-bottom: 5px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  margin-top: 5px;
}

.product_go {
  color: #fbdd21;
}

.production_title {
  margin-left: 4px;
}

.border_progress {
  width: 0;
  height: 1px;
  background: #bababa;
  position: absolute;
  top: 0;
  transition: 0.1s all;
}

.bottom_tab {
  width: 33%;
  text-align: center;
  float: left;
  color: #c9c9c9;
  padding: 10px 0;
}

.bottom_tab_icon {
  width: 44px;
}

.bottom_tab_span {
  line-height: 28px;
  border-bottom: 2px solid transparent;
  font-weight: 600;
  font-size: 16px;
  display: inline-block;
  padding: 0 4px;
  transition: 0.5s all;
}
.video_container {
  height: calc(100vh - 2rem);
  overflow: hidden;
  position: relative;
}
.tab_active .bottom_tab_span {
  border-bottom: 2px solid #fff;
  color: #fff;
}

.icon-shoucang {
  transition: 0.5s all;
}

.fabulous_active {
  color: #f44;
  animation: showHeart 0.5s ease-in-out 0s;
}

/*animation-name：用来调用@keyframes定义好的动画，与@keyframes定义的动画名称一致*/
/*animation-duration ：指定元素播放动画所持续的时间*/
/*animatino-timing-function ： 和transition中的transition-timing-function 中的值一样。根据上面@keframes中分析的animation中可能存在多个小动画，因此这里的值设置是针对每一个小动画所在时间范围内的属性变换速率。*/
/*animation-delay：定义在浏览器开始执行动画之前等待的时间，这里是指整个animation执行之前的等待时间，而不是上面说的多个小动画*/
/*animation-iteration-count：定义动画的播放次数，其通常为整数，默认是1,；取值为infinite，动画将无限次的播放。*/
/*animation-direction：主要用来设置动画播放方向*/
@keyframes showHeart {
  0% {
    color: #f44;
    transform: scale(1);
  }

  25% {
    color: #fff;
    transform: scale(0);
  }

  80% {
    color: #f44;
    transform: scale(1.2);
  }

  100% {
    color: #f44;
    transform: scale(1);
  }
}

/*分享样式*/
.share_hover {
  position: fixed;
  display: none;
}

.share_box {
  z-index: 1002;
  transition: 0.5s;
}

.share_tips {
  text-align: center;
  line-height: 38px;
  color: #333;
}

.share_ul {
  box-sizing: border-box;
  padding: 0 25px 25px;
  border-bottom: 1px solid #e8e8e8;
}

.share_li {
  float: left;
  width: 33%;
  text-align: center;
}

.share_li i {
  font-size: 44px;
}

.share_cancel {
  text-align: center;
  line-height: 48px;
  color: #777;
  text-align: center;
}

.pengyouquan {
  color: #47d000;
}

.pengyouquan_li {
  animation: rotating 8s linear infinite;
}

@keyframes rotating {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.weixin {
  color: #20ca2e;
}

.lianjie {
  color: #cdcdcd;
}

.share_active {
  bottom: 0px;
}

/*评论样式*/
::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.2);
}

:-moz-placeholder {
  color: rgba(0, 0, 0, 0.2);
}

::-moz-placeholder {
  color: rgba(0, 0, 0, 0.2);
}

:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.2);
}

.comment_container {
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.comment_box {
  padding: 0 15px 52px 15px;
}

.comment_top {
  text-align: center;
  font-size: 12px;
  color: #000;
  line-height: 40px;
}

.guanbi3 {
  float: right;
  font-size: 12px;
  padding: 0 10px;
  position: absolute;
  right: 6px;
}

.comment_li {
  margin-bottom: 20px;
  font-size: 14px;
  text-align: left;
}

.comment_author_left {
  float: left;
}

.comment_author_left img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.comment_author_right {
  margin-left: 46px;
  padding-top: 4px;
}

.comment_author_top {
  position: relative;
}

.comment_author_name {
  margin-bottom: 6px;
  color: #777;
}

.icon-shoucang1_box {
  position: absolute;
  right: 0px;
  top: 0;
  text-align: center;
  color: #777;
}

.comment_author_text {
  color: #555;
  margin-bottom: 10px;
  padding-right: 35px;
}

.comment_replay_box {
  padding-left: 46px;
  box-sizing: border-box;
}

.comment_replay_li {
  margin-bottom: 10px;
}

.comment_replay_left {
  float: left;
}

.comment_replay_left img {
  width: 25px;
  height: 25px;
  border-radius: 50%;
}

.comment_replay_right {
  margin-left: 35px;
  padding-top: 2px;
}

.comment_replay_top {
  position: relative;
  margin-bottom: 6px;
}

.comment_replay_text {
  padding-right: 35px;
  margin-bottom: 10px;
  color: #555;
}

.comment_author_text span,
.comment_replay_text span {
  color: #999;
  font-size: 13px;
  margin-left: 6px;
}

.shoucang1_num {
  text-align: center;
  width: 30px;
  font-size: 12px;
  /* right: -4px; */
  position: relative;
}

.comment_ul {
  height: 400px;
  overflow-y: auto;
}

.comment_input_box {
  position: fixed;
  bottom: 0;
  z-index: 2999;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  background: #fff;
  padding: 10px 15px;
  box-sizing: border-box;
}

/*.comment_form {*/
/**/
/*}*/

.comment_input {
  border: none;
  resize: none;
  width: 80%;
  float: left;
  color: #555;
  caret-color: #f44;
  line-height: 0.44rem;
}

.comment_input_right {
  float: right;
}

.comment_i {
  font-size: 22px;
  color: #999;
  transition: 0.3s;
}

.comment_i_active {
  color: #f44;
}

.icon-zanwupinglun {
  font-size: 100px;
  color: #777;
}

.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateY(80px);
}

.v-enter-active,
.v-leave-active {
  transition: all 0.5s ease;
}

/*添加进场效果*/
.v-move {
  transition: all 1s ease;
}

.v-leave-active {
  position: absolute;
}

.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}

.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}

.love_active {
  color: #f44;
}

.dialog_MC {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 99;
  display: block;
  width: 100% !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
}
.setContent {
  position: absolute;
  width: 6rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 0.2rem;
}
.setTitle {
  width: 100%;
  padding: 0.25rem 0;
  text-align: center;
  color: #333;
  font-size: 0.32rem;
}
.setText {
  width: 90%;
  margin: 0 auto;
  position: relative;
}
.setText textarea {
  display: block;
  padding: 0.2rem 0.3rem;
  background-color: #f0f0f0;
  font-size: 0.26rem;
  width: 100%;
  height: 3rem;
}
.setbtns {
  width: 100%;
  display: flex;
  align-items: center;
  height: 0.8rem;
  justify-content: space-around;
  position: relative;
  font-size: 0.32rem;
  border-top: 0.02rem solid #e2e2e2;
  margin-top: 0.25rem;
  text-align: center;
}
.setQuxiao {
  width: 50%;
  display: block;
  color: #000000;
  border-right: 0.02rem solid #e2e2e2;
}
.setYes {
  width: 50%;
  display: block;
  color: #ff410a;
}
.close {
  position: absolute;
  right: 0.15rem;
  top: 0.15rem;
  display: block;
  width: 0.4rem;
  z-index: 9;
}
</style>
